import { render, staticRenderFns } from "./UploadIcon.vue?vue&type=template&id=2bdc3741&scoped=true"
import script from "./UploadIcon.vue?vue&type=script&lang=js"
export * from "./UploadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc3741",
  null
  
)

export default component.exports